import { standardLimit } from "./standardLimit";

export const isLoanJumbo = ({
  countyLimits,
  county,
  state,
  countyFips,
  stateFips,
  loanAmount,
  propertyType,
}) => {
  // FIPS lookup
  let limit = null;
  if (countyFips && stateFips) {
    // Convert to numbers for comparison
    const countyFipsWithoutState = countyFips.substring(2);
    const countyFipsNum = parseInt(countyFipsWithoutState, 10);
    const stateFipsNum = parseInt(stateFips, 10);
    limit = countyLimits.find(
      (limit) =>
        limit.fipsCountyCode === countyFipsNum &&
        limit.fipsStateCode === stateFipsNum
    );
  }

  // Fallback to county and state strings
  if (!limit && county && state) {
    limit = countyLimits.find((limit) => {
      if (
        limit.countyName.toLowerCase() === county.toLowerCase() &&
        limit.state.toLowerCase() === state.toLowerCase()
      ) {
        return true;
      } else {
        //limits always end in county. some address listings may not.
        const countyWithSuffix = county.toLowerCase() + " county";
        return limit.countyName.toLowerCase() === countyWithSuffix; // no need to check state in edge case
      }
    });
  }

  const finalLimit = limit ? limit : standardLimit;

  switch (propertyType) {
    case "Single":
    case "Townhome":
    case "Condo":
      return loanAmount > finalLimit.oneUnitLimit;
    case "Duplex":
      return loanAmount > finalLimit.twoUnitLimit;
    case "Triplex":
      return loanAmount > finalLimit.threeUnitLimit;
    case "Quadplex":
      return loanAmount > finalLimit.fourUnitLimit;
  }
};
